import { nanoid } from 'nanoid';
import { assignProperties, Unboxed } from '../../../../schemaUtils';
import { MEDIA_FILE_IMAGE as QuestionType } from '../../../../types/dialog.generated';
import { config } from './MediaFileImage.config';

type AnswerType = Unboxed<QuestionType['data']['answers']>;

export function generateQuestion(answers: AnswerType[], overrides: Partial<QuestionType['data']> = {}): QuestionType {
  return {
    id: nanoid(10),
    data: assignProperties<QuestionType['data']>(
      {
        type: config.name,
        text: '',
        answers,
        logicRules: [],
      },
      overrides,
    ),
  };
}

export function generateAnswer(overrides: Partial<AnswerType> = {}): AnswerType {
  return {
    id: nanoid(10),
    text: '',
    image: { src: '' },
    textPosition: 'AFTER_MEDIAFILE',
    ...overrides,
  };
}
